<script setup>
import { onMounted, ref } from "vue";
import { ElNotification } from "element-plus";
import http from "@/http";
import { useStore } from "vuex"; // Import the useStore function
const store = useStore();

const props = defineProps(["close", "board_id"]);

const loading = ref(false);
const baseUrl = ref(`${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/`);
const uploadUrl = ref(
  `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`
);
const uploadHeader = ref({ Authorization: `${store.state.accessToken}` });
const showEditingModal = ref(false);
const selectedProtocolId = ref(null);
const file_id = ref(null);
const limit = ref(20);
const currentPage = ref(1);
const district_id = ref(null);
const can_moderator_upload = ref(false);
const protocols = ref([]);
const protocolsCount = ref(0);
const regionsLoading = ref(false);
const districtsLoading = ref(false);
const regions = ref([]);
const districts = ref([]);
const selectedRegion = ref(null);
const selectedDistrict = ref(null);

const handleCurrentChange = () => {
  getAllProtocols();
};

const handleSizeChange = () => {
  currentPage.value = 1;
  getAllProtocols();
};

const createProtocol = async () => {
  try {
    loading.value = true;
    await http.post("api/v1/districts/documents/protocol", {
      board_id: props.board_id,
      file_id: file_id.value,
    });

    if (store.state.role == "moderator") {
      can_moderator_upload.value = false;
    }
    ElNotification.success({
      message: "Muvoffaqiyatli yuklandi",
    });
  } catch (error) {
    ElNotification.error({
      message:
        JSON.parse(error?.message)?.message ||
        "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
      type: "error",
    });
  } finally {
    loading.value = false;
  }
};

const changeProtocol = async () => {
  try {
    loading.value = true;
    await http.put(
      `api/v1/districts/documents/protocol/${selectedProtocolId.value}`,
      {
        file_id: file_id.value,
      }
    );

    ElNotification.success({
      message: "Muvoffaqiyatli yuklandi",
    });
    closeEditingModal();
    getAllProtocols();
  } catch (error) {
    ElNotification.error({
      message:
        JSON.parse(error?.message)?.message ||
        "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
      type: "error",
    });
  } finally {
    loading.value = false;
  }
};

const onSuccessUpload = (res) => {
  file_id.value = res.hashId;
  if (store.state.role == "moderator") {
    createProtocol();
  } else if (store.state.role == "admin") {
    changeProtocol();
  }
  this.$emit('protocolFileUploaded')
};

const onErrorUpload = (error) => {
  props.close();
  ElNotification.error({
    message:
      JSON.parse(error?.message)?.message ||
      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
    type: "error",
  });

  loading.value = false;
};
const onExceed = (files) => {
  console.log("exceeds", files);
  // this.form.file[0] = files[0]
};

const getSingleProtocol = async () => {
  try {
    loading.value = true;
    await http.get("api/v1/districts/documents/protocol/single", {
      params: {
        board_id: props.board_id,
        district_id: district_id.value,
      },
    });
    can_moderator_upload.value = false;
  } catch (error) {
    can_moderator_upload.value = true;
  } finally {
    loading.value = false;
  }
};

const getAllProtocols = async () => {
  try {
    loading.value = true;
    const { data } = await http.get("api/v1/districts/documents/protocol", {
      params: {
        board_id: props.board_id,
        limit: limit.value,
        offset: limit.value * (currentPage.value - 1),
        region_id: selectedRegion.value,
        district_id: selectedDistrict.value,
      },
    });
    protocols.value = data.results;
    protocolsCount.value = data.count;
  } catch (error) {
    ElNotification.error({
      message:
        "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
      type: "error",
    });
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  district_id.value = JSON.parse(
    localStorage.getItem("openBudget")
  ).user.district_id;
  if (store.state.role == "moderator") {
    getSingleProtocol();
  }

  if (store.state.role == "admin") {
    getRegions();
    getAllProtocols();
  }
});

const closeEditingModal = () => {
  showEditingModal.value = false;
  selectedProtocolId.value = null;
  file_id.value = null;
};

const downloadAllAsExcel = () => {
  loading.value = true;
  http
    .get(`api/v1/districts/documents-excel`, {
      params: {
        board_id: props.board_id,
      },
      responseType: "blob",
    })
    .then((res) => {
      const url = URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        })
      );
      const header = res.headers.get("Content-Disposition");
      const parts = header.split(";");
      let fileName = parts[1].split("=")[1];
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((err) => {
      ElNotification({
        title: "Ogohlantirish",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "warning",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

const downloadProtocol = (id = null) => {
  loading.value = true;
  http
    .get(`api/v1/districts/documents/protocol/single`, {
      params: {
        district_id: id ?? district_id.value,
        board_id: props.board_id,
      },
    })
    .then(({ data }) => {
      const link = document.createElement("a");
      link.href = baseUrl.value + data.file_id;
      console.log(link.href);
      link.setAttribute("download", "file");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((err) => {
      ElNotification({
        title: "Ogohlantirish",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "warning",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

const getRegions = () => {
  regionsLoading.value = true;
  http
    .get("/api/v1/regions")
    .then(({ data }) => {
      regions.value = data.regions;
      selectedDistrict.value = null;
      getDistricts();
      getAllProtocols();
    })
    .catch(() => {})
    .finally(() => {
      regionsLoading.value = false;
    });
};
const getDistricts = () => {
  districtsLoading.value = true;
  http
    .get("/api/v1/districts", {
      params: {
        region_id: selectedRegion.value,
      },
    })
    .then(({ data }) => {
      districts.value = data.districts;
      // selectedDistrict.value = districts.value[0].id;
      getAllProtocols();
    })
    .catch(() => {})
    .finally(() => {
      districtsLoading.value = false;
    });
};

const onEditProtocol = async (protocol_id) => {
  console.log(protocol_id, "protocol id");
  selectedProtocolId.value = protocol_id;
  showEditingModal.value = true;
};
</script>

<template>
  <div>
    <div v-if="store.state.role == 'admin'">
      <div class="filters">
        <el-button
          class="upload-demo"
          type="success"
          style="margin-right: 10px"
          @click="downloadAllAsExcel"
        >
          <img
            style="margin-right: 10px"
            alt=""
            src="@/assets/images/icons/download.svg"
          />
          Yuklab olish
        </el-button>

        <el-select
          placeholder="Viloyatlar"
          v-model="selectedRegion"
          @change="getRegions"
          :loading="regionsLoading"
        >
          <el-option value="" label="Barchasi" />
          <el-option
            v-for="region in regions"
            :key="region.id"
            :value="region.id"
            :label="region.title"
          />
        </el-select>
        <el-select
          placeholder="Tuman/Shaxar"
          v-model="selectedDistrict"
          @change="getDistricts"
          :loading="districtsLoading"
        >
          <el-option value="" label="Barchasi" />

          <el-option
            v-for="district in districts"
            :key="district.id"
            :value="district.id"
            :label="district.title"
          />
        </el-select>
      </div>

      <el-table :data="protocols" border height="calc(100vh - 260px)">
        <el-table-column prop="region" label="Viloyat" min-width="150" />
        <el-table-column prop="district" label="Tuman/Shahar" min-width="100" />
        <el-table-column
          prop="file_id"
          label="protocol fayl mavjudligi"
          min-width="100"
        >
          <template #default="scope">
            <div
              v-if="scope.row.file_id"
              style="display: flex; align-items: center; gap: 10px"
            >
              <p class="protocol_exists"></p>
              <p>mavjud</p>
            </div>
            <div
              v-if="!scope.row.file_id"
              style="display: flex; align-items: center; gap: 10px"
            >
              <p class="protocol_exists protocol_not_exists"></p>
              <p>mavjud emas</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="tahrirlash/ochirish">
          <template #default="scope">
            <el-button
              :disabled="!scope.row.file_id"
              size="small"
              @click="onEditProtocol(scope.row.id)"
              type="primary"
              >Tahrirlash</el-button
            >
            <el-button
              :disabled="!scope.row.file_id"
              size="small"
              class="upload-demo"
              type="success"
              @click="downloadProtocol(scope.row.district_id)"
            >
              <img
                style="margin-right: 10px"
                alt=""
                src="@/assets/images/icons/download.svg"
              />
              Yuklab olish
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div>Jami soni: {{ protocolsCount }}</div>
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="protocolsCount"
          v-model:page-size="limit"
          v-model:current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-row v-if="store.state.role == 'moderator'">
      <el-col v-if="can_moderator_upload" :xs="24" :sm="18" :lg="16" :xl="14">
        <el-form-item label="Protocol faylini yuklang" prop="file">
          <el-upload
            ref="uploadRef"
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeader"
            :multiple="false"
            accept="application/pdf"
            :limit="1"
            :on-exceed="onExceed"
            :on-success="onSuccessUpload"
            :on-error="onErrorUpload"
          >
            <template #trigger>
              <el-button style="width: 100%" type="primary">
                Protocol faylni tanlang
              </el-button>
            </template>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col v-if="!can_moderator_upload" :xs="24" :sm="18" :lg="16" :xl="14">
        <el-form-item label="Ro'yxatni yuklab olish">
          <el-button
            class="upload-demo"
            type="success"
            @click="downloadProtocol()"
          >
            <img
              style="margin-right: 10px"
              alt=""
              src="@/assets/images/icons/download.svg"
            />
            Mavjud protocolni yuklab olish
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>

    <el-dialog
      v-model="showEditingModal"
      @close="closeEditingModal"
      title="Protocol faylni tahrirlash"
      align-center
    >
      <el-form-item label="Protocol faylini yuklang" prop="file">
        <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeader"
          :multiple="false"
          accept="application/pdf"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
        >
          <template #trigger>
            <el-button style="width: 100%" type="primary">
              Protocol faylni tanlang
            </el-button>
          </template>
        </el-upload>
      </el-form-item>
    </el-dialog>
  </div>
</template>

<style scoped>
.protocol_exists {
  width: 20px;
  text-align: center;
  height: 20px;
  background: rgb(16, 191, 48);
  border-radius: 50%;
}

.protocol_not_exists {
  background: rgb(255, 0, 0);
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
